import produce from 'immer';

function wrapReducerWithImmer(reducer) {
  // reducer must return value because literal don't support immer
  return function (state, payload) {
    return typeof state === 'object' ? produce(state, function (draft) {
      var next = reducer(draft, payload);
      if (typeof next === 'object') return next;
    }) : reducer(state, payload);
  };
}

var immerPlugin = function immerPlugin(config) {
  return {
    onReducer: function onReducer(reducer, model) {
      if (!config || !config.whitelist && !config.blacklist || config.whitelist && model in config.whitelist || config.blacklist && !(model in config.blacklist)) {
        return wrapReducerWithImmer(reducer);
      }
    }
  };
};

export default immerPlugin;